import config from "config/appConfig";

import type { IStateProps } from "utils/StateOf";
import createStoreFunction from "utils/createStore";

import type {
	TournamentLeaderboardPlaceModel,
	TournamentLeaderboardUserModel,
	TournamentModel
} from "../../types/TournamentModel";

const localStorageKey = `${config.GLOBAL_CONSTANTS.LOCAL_STORAGE_PREFIX}${config.HOOK_STORAGE_KEYS.TOURNAMENTS_DATA}`;

export interface Values {
	loading: boolean;
	joining: boolean;

	tournaments: TournamentModel[];

	loadingLeaderboard: boolean;
	leaderboardResults: TournamentLeaderboardPlaceModel[];
	leaderboardUser?: TournamentLeaderboardUserModel;
}

export const initialState: IStateProps<Values> = {
	loading: false,
	joining: false,

	tournaments: [],

	loadingLeaderboard: false,
	leaderboardResults: [],
	leaderboardUser: undefined
};

export default createStoreFunction<Values>({
	initialState,
	persistant: true,
	persistantName: localStorageKey
});
